// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609242104/js/" + chunkId + "." + {"44":"e58cd79f","225":"85dc86f3","481":"bff2bbb8","486":"f2b1df3e","770":"c7964492"}[chunkId] + ".0.023640237178984447.chunk.js";
};